"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navbar = void 0;
/* eslint-disable @typescript-eslint/no-var-requires */
var react_1 = __importStar(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
// import { toast } from 'react-toastify';
var classnames_1 = __importDefault(require("classnames"));
require("./Navbar.scss");
var actions_1 = require("@app/features/auth/state/actions");
var ToggleAspera_1 = require("./ToggleAspera");
var selectors_1 = require("@app/features/transfers/state/selectors");
var actions_2 = require("@app/features/transfers/state/actions");
// import { Config } from '@app/shared/config';
// import { SITEWIDE_WARNING } from '@app/shared/constants';
var matomo_1 = require("@app/shared/matomo");
var CurrentUser_1 = require("./CurrentUser");
var blastLogo = require('@static/blast-logo.png');
var initialState = {
    isMenuActive: false
};
var Navbar = /** @class */ (function (_super) {
    __extends(Navbar, _super);
    function Navbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        _this.toggleMenu = function () {
            _this.setState({ isMenuActive: !_this.state.isMenuActive });
        };
        _this.handleToggleAspera = function () {
            var matomo = new matomo_1.MatomoTracker();
            _this.props.onClearStagedFiles();
            if (_this.props.asperaEnabled) {
                matomo.trackEvent('User', 'Toggle Aspera', 'Off');
                _this.props.onStopAspera();
            }
            else {
                matomo.trackEvent('User', 'Toggle Aspera', 'On');
                _this.props.onStartAspera();
            }
        };
        return _this;
    }
    Navbar.prototype.render = function () {
        var props = this.props;
        var isMenuActive = this.state.isMenuActive;
        // Temporary global toast message
        /*
        const toastMsg =
          <div className={'message-info'}>
            <span className="icon">
              <i className="fas fa-exclamation-triangle"/>
            </span>
            <p className={'important-msg'}>
              We’re experiencing a service issue that may affect some users.<br/>
              If you’re impacted, please email us at <strong><a
                href={`mailto:${Config.CONTACT_EMAIL}`}>{Config.CONTACT_EMAIL}</a></strong>. Thanks for your patience.
            </p>
          </div>;
        if (!toast.isActive(SITEWIDE_WARNING)) {
          toast.warn( toastMsg, {
            autoClose: false,
            closeOnClick: false,
            toastId: SITEWIDE_WARNING
          });
        }
        */
        return (react_1.default.createElement("nav", { className: "navbar blast-navbar", role: "navigation", "aria-label": "main navigation" },
            react_1.default.createElement("div", { className: "navbar-brand" },
                react_1.default.createElement(react_router_dom_1.Link, { to: "/dash", className: "navbar-item" },
                    react_1.default.createElement("img", { src: blastLogo.default, width: "230", height: "54" })),
                react_1.default.createElement("a", { className: classnames_1.default('navbar-burger', { 'is-active': isMenuActive }), onClick: this.toggleMenu },
                    react_1.default.createElement("span", { "aria-hidden": "true" }),
                    react_1.default.createElement("span", { "aria-hidden": "true" }),
                    react_1.default.createElement("span", { "aria-hidden": "true" }))),
            react_1.default.createElement("div", { className: classnames_1.default('navbar-menu', { 'is-active': isMenuActive }) },
                react_1.default.createElement("div", { className: "navbar-end" },
                    !react_device_detect_1.isMobile &&
                        react_1.default.createElement("div", { className: "navbar-item is-hidden-mobile" },
                            react_1.default.createElement(ToggleAspera_1.ToggleAspera, { enabled: props.asperaEnabled, onToggle: this.handleToggleAspera })),
                    props.isInternal &&
                        react_1.default.createElement("div", { className: "navbar-item", "data-test": "user-invite-item" },
                            react_1.default.createElement("div", { className: "field is-grouped" },
                                react_1.default.createElement(react_router_dom_1.Link, { to: "/dash/users/invite", className: "button is-light", "data-test": "user-invite-link" },
                                    react_1.default.createElement("span", { className: "icon" },
                                        react_1.default.createElement("i", { className: "fas fa-user-plus" })),
                                    react_1.default.createElement("span", null, "Invite")))),
                    this.props.currentUser &&
                        react_1.default.createElement("div", { className: "navbar-item is-hidden-mobile" },
                            react_1.default.createElement(CurrentUser_1.CurrentUser, { user: this.props.currentUser })),
                    react_1.default.createElement("a", { className: "navbar-item", "data-test": "logout-button", onClick: function () { return props.onLogout(true); }, title: "Logout" },
                        react_1.default.createElement("span", { className: "icon is-large" },
                            react_1.default.createElement("i", { className: "fas fa-sign-out-alt fa-2x" })))))));
    };
    return Navbar;
}(react_1.Component));
exports.Navbar = Navbar;
var mapStateToProps = function (store) {
    return {
        currentUser: store.auth.userInfo,
        isInternal: store.auth.userInfo ? store.auth.userInfo.isInternal : false,
        asperaEnabled: selectors_1.isAsperaEnabled(store)
    };
};
var mapDispatchToProps = {
    onClearStagedFiles: actions_2.clearStagedFiles,
    onLogout: actions_1.logout,
    onStartAspera: actions_2.startAspera,
    onStopAspera: actions_2.stopAspera
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Navbar);
